module.exports = __webpack_public_path__ + "img/UmgarntVonRosa.ac782b5f.jpg";